import { filter, prop, propEq } from "ramda";

function AsyncDialog() { };

const CLASSES = 'fv-async-dialog fv-dialog ';

AsyncDialog.prototype._target = null;
AsyncDialog.prototype._isOpen = false;
AsyncDialog.prototype._resolveCallback = null;

AsyncDialog.prototype.width = 400;
AsyncDialog.prototype.buttons = [];
AsyncDialog.prototype.title = '';
AsyncDialog.prototype.class = '';
AsyncDialog.prototype.autoFocusControl = null;

AsyncDialog.prototype.closeWithResult = function (value) {
    if (this._isOpen) {
        this._resolveCallback(value);
        this._resolveCallback = null;
        this._isOpen = false;
        this._target.dialog("destroy");
    } else {
        throw Error("This dialog is not currently open.");
    }
};

AsyncDialog.prototype.setTarget = function (targetElement) {
    this._target = $(targetElement);
};

AsyncDialog.prototype.showAsync = async function () {
    let dialogProperties = {
        closeOnEscape: false,
        dialogClass: CLASSES + this.class,
        draggable: false,
        modal: true,
        width: this.width,
        title: this.title,
        buttons: this.buttons,
        close: (e) => {
            $(e.target).off('keyup.dialog');
        },
    };

    const focusControl = this.autoFocusControl;

    const enterButtons = filter(
        prop('allowEnter'),
        this.buttons,
    );

    if (enterButtons.length > 1) {
        throw new Error('Cannot have multiple confirm buttons');
    }

    dialogProperties.open = function (e, ui) {
        if (focusControl) {
            var $control = $(e.target).find(focusControl);

            if ($control.length) {
                $control.focus();
            }
        }

        if (enterButtons.length === 1) {
            $(e.target).on('keyup.dialog', (e) => {
                if (e.key === 'Enter') {
                    enterButtons[0].click();
                }
            });
        }
    };

    this._target.dialog(dialogProperties);

    this._isOpen = true;

    return new Promise(function (resolve) {
        this._resolveCallback = resolve;
    }.bind(this));
}

AsyncDialog.makeButton = (text, result) =>
    $("<input type='button' />")
        .attr("value", text)
        .addClass("ui-button")
        .data("result", result);

export default AsyncDialog;
